// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { classNames } from '@shared/ui-kit/utils/classnames';
import { isFieldValueEmpty } from '@shared/ui-kit/utils/is-field-value-empty';
import { forwardRef, type ComponentProps, type FC } from 'react';

export const Input: FC<ComponentProps<'input'> & { error?: boolean }> = forwardRef(
  (
    { className, type, error, readOnly, required, value, defaultValue, ...props },
    ref,
  ) => {
    const resolvedValue = value ?? defaultValue;
    const isEmpty = isFieldValueEmpty(resolvedValue);
    const isRequired = Boolean(required);

    return (
      <input
        type={type}
        value={value}
        defaultValue={defaultValue}
        required={required}
        className={classNames('input-common', className, {
          'input-error': error,
          'input-readonly': readOnly,
          'input-filled': !error && !readOnly && !isEmpty,
          'input-empty-required': !error && !readOnly && isEmpty && isRequired,
          'input-empty': !error && !readOnly && isEmpty && !isRequired,
        })}
        ref={ref}
        readOnly={readOnly}
        aria-invalid={error || undefined}
        {...props}
      />
    );
  },
);
